export default __webpack_public_path__ + "static/media/mastercard.cc9a46cc.svg";